<template>
  <div class="invoice_container" :style="`min-height:${mh}px`">
    <div class="query_conf">
      <Row :gutter="16" class="line1">
        <Col span="8" class="key">
          <span class="title">关键词：</span>
          <Input v-model.trim="conf.key" placeholder="可输入发票号/目的地/起运地/收货人名称"></Input>
        </Col>
        <Col span="6">
          <span class="title">发票日期：</span>
          <DatePicker class="dateselect" v-model.trim="dateRange" type="daterange" placement="bottom-start" split-panels clearable :editable="false" placeholder="请选择起始与结束日期" @on-change="dateSearch" style="width:100%;"></DatePicker>
        </Col>
        <Col span="10">
          <Button type="primary" class="btn search" :loading="isShowModalLoader" @click.prevent="searchHandle"><span>查询</span></Button>
          <Button type="primary" class="btn cert_btn" @click.prevent="certHandle"><span>生成证书</span></Button>
        </Col>
      </Row>
    </div>
    <div class="content">
      <Table :columns="query.columns" :data="query.list" :loading="loaderQuery" no-data-text="暂无记录"></Table>
      <Page :total="query.total" :page-size="pageSize" size="small" @on-change="getQueryList" v-if="query.total > pageSize"></Page>
      <Loader :loadType="1" v-show="isShowModalLoader" class="black" style="top:-20px;"></Loader>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/layout/Loader'
export default {
  name: 'RulesDecideCertList',
  components: { Loader },
  props: ['mh'],
  data () {
    return {
      dateRange: '',
      conf: {
        key: null,
        startTime: null,
        endTime: null
      },
      pageSize: 10,
      loaderQuery: false,
      isShowModalLoader: false,
      query: {
        total: 0,
        columns: [
          {
            title: '发票号',
            key: 'invoiceCode',
            align: 'center',
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.invoiceCode}
              }, params.row.invoiceCode)
            }
          },
          {
            title: '发票日期',
            key: 'invoiceTime',
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.invoiceTime ? this.$options.filters.dataFormat(params.row.invoiceTime, 'dateTime.short4') : '-')
            }
          },
          {title: 'FTA', key: 'ftaName', align: 'center'},
          {title: '起运地', key: 'exporter', align: 'center'},
          {title: '出口人名称', key: 'exporterName', align: 'center'},
          {title: '目的地', key: 'importer', align: 'center'},
          {title: '收货人名称', key: 'consigneeName', align: 'center'},
          // {
          //   title: '状态',
          //   key: 'status',
          //   align: 'center',
          //   width: 110,
          //   render: (h, params) => {
          //     return h('span', {
          //       style: { color: ['#bbb', '#00b55f'][parseInt(params.row.status)] }
          //     }, parseInt(params.row.status) === 1 ? '判定成功' : '判定失败')
          //   }
          // },
          {
            title: '创建时间',
            key: 'createTime',
            align: 'center',
            render: (h, params) => {
              return h('span', this.$options.filters.dataFormat(params.row.createTime, 'dateTime.short4'))
            }
          },
          {
            title: '操作',
            key: 'action',
            align: 'center',
            width: 90,
            render: (h, params) => {
              return h('div', {
                style: {display: 'flex', justifyContent: params.row.status === 2 ? 'space-between' : 'space-evenly'},
                class: 'opr'
              }, [
                h('router-link', {
                  style: {color: '#EE8909'},
                  class: 'line2',
                  props: {
                    to: {name: 'RulesDecideCertDetail', params: {id: params.row.id}}
                  }
                }, '查看')
              ])
            }
          }
        ],
        list: []
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getQueryList()
    })
  },
  methods: {
    certHandle () {
      this.$router.push({name: 'RulesDecideCertCreate'})
    },
    searchHandle () {
      this.getQueryList(1)
    },
    getQueryList (page = 1) {
      if (this.isShowModalLoader) return
      this.$Loading.start()
      this.isShowModalLoader = true
      this.loaderQuery = true
      this.$api.coo.cert.list(this._.assign({page: page || 1, size: this.pageSize}, this.conf), {
        success: response => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            this.query.list = response.data.data.result || []
            this.query.total = response.data.data.count || 0
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.isShowModalLoader = false
          this.loaderQuery = false
        },
        error: errorMsg => {
          this.isShowModalLoader = false
          this.loaderQuery = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    dateSearch (dateArr, dateType) {
      if (!this._.isEmpty(dateArr) && dateType === 'date') {
        this.conf.startTime = dateArr[0]
        this.conf.endTime = dateArr[1]
      } else {
        this.conf.startTime = null
        this.conf.endTime = null
        this.dateRange = ''
      }
    }
  }
}
</script>
<style scoped>
  .invoice_container{
    background-color: #fff;
    padding: 28px 24px 42px;
  }
  .query_conf{
    font-size: 13px;
  }
  .query_conf >>> .ivu-row{
    margin-bottom: 20px;
  }
  .query_conf >>> .ivu-row .ivu-col{
    display: flex;
    align-items: center;
  }
  .query_conf >>> .ivu-row .ivu-col .title{
    white-space: nowrap;
  }
  .query_conf >>> .ivu-row .ivu-col .ivu-input{
    border-color: #DBDBDB;
    border-radius: 2px;
  }
  .query_conf >>> .ivu-row .ivu-col .ivu-input:focus{
    border-color: #57a3f3;
  }
  .btn{
    width: 110px;
    border: 1px solid #1F8AFD;
    border-radius: 3px;
    height: 32px;
    /*line-height: 32px;*/
    float: left;
    /*font-size: 12px;*/
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
  }
  .btn span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btn.search{
    background-color: #1F8AFD;
    color: #fff;
    margin-right: 10px;
  }
  .btn.cert_btn{
    background-color: #17BB6D;
    border-color: #17BB6D;
  }
  .btn.cert_btn span{
    background: url("~@/assets/images/coo/icon_zhengshu.png") 0 5px no-repeat transparent;
    background-size: 13px auto;
    padding-left: 16px;
  }
  .btn.ivu-btn-loading{
    cursor: default;
  }
  .btn.ivu-btn-loading span{
    position: static;
    transform: none;
  }
  .content{
    margin-top: 20px;
    position: relative;
  }
  .content >>> .ivu-table-wrapper{
    border: 0 none;
    box-shadow: 0 2px 4px 0 rgba(196,196,196,0.50);
  }
  .content >>> .ivu-table{
    color: #333;
  }
  .content >>> .ivu-table th{
    background-color: #F9F9F9;
    font-size: 12px;
    font-weight: normal;
    border-color: #F1F1F1;
  }
  .content >>> .ivu-table td{
    font-size: 13px;
    border-color: #F1F1F1;
  }
  .content >>> .ivu-table .ivu-checkbox-wrapper{
    margin-right: 0;
  }
  .content >>> .ivu-table .tb_select .ivu-table-cell{
    padding-right: 0;
  }
  .content >>> .ivu-table .tb_company .ivu-table-cell{
    padding-left: 0;
  }
  .content >>> .ivu-table .opr a.line2:after{
    /*text-decoration: underline;*/
    bottom: 0;
  }
  .ivu-page{
    margin-top: 20px;
    text-align: center;
  }
  .ivu-page >>> .ivu-page-item-active{
    background-color: #1F8AFD;
    border-color: #1F8AFD;
  }
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/CertList.vue